<template lang="pug">
  .about-us.page
    .about-us__header
      img(src="@/assets/images/aboutUs/aboutUs.jpg")
    .about-us__body
      .container
        .about-us__content.about-us-content
          .about-us-content__title
            h1.title О нас
          .about-us-content__body
            .content
              .content__block(
                v-html="text"
              )
              .content__block
                .video
                  iframe(
                    width='560'
                    height='315'
                    src='https://www.youtube.com/embed/dE_c4bwpCQw'
                    frameborder='0'
                    allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
                    allowfullscreen=''
                  )
    .about-us__footer.page__footer
      main-footer
</template>

<script>
import MainFooter from "@/components/footer/Footer.vue";

export default {
  name: "AboutUs",
  components: {
    MainFooter
  },
  data() {
    return {
      text:
        "<p>Государственное бюджетное учреждение «Республиканский центр по организации оздоровления, отдыха и занятости детей и подростков «Лето» курирует работу детских оздоровительных лагерей республики всех форм отдыха, осуществляет взаимодействие с заинтересованными министерствами и ведомствами, муниципалитетами, предприятиями и организациями, в управлении которых находятся оздоровительные организации.</p>" +
        "<strong><p>Основные направления работы Республиканского центра:</p></strong>" +
        "<ul>" +
        "<li><p>координация реализации Программы отдыха детей и молодежи Республики Татарстан;</p></li>" +
        "<li><p>ежегодное обновление реестра лагерей Республики Татарстан, участвующих в оздоровительной кампании, проведение мониторинга состояния материально-технической базы ДОЛ, проведение паспортизации детских оздоровительных учреждений РТ;</p></li>" +
        "<li><p>организация и проведение конкурсных процедур на приобретение путевок для детей и молодежи, заключение в порядке, определяемом законодательством, контрактов (договоров) на приобретение путевок в оздоровительные и санаторные учреждения, лагеря, расположенные на территории Российской Федерации;</p></li>" +
        "<li><p>сбор, анализ заявок, согласование, систематизация и утверждение программ профильных смен и палаточных лагерей, организация Смотра профильных программ по линии Министерства по делам молодежи РТ;</p></li>" +
        "<li><p>методическая и консультативная помощь организаторам отдыха и оздоровления детей и молодежи в течение всей оздоровительной кампании;</p></li>" +
        "<li><p>ежегодная организация и проведение Школы вожатых, семинаров для организаторов летнего отдыха, для начальников лагерей, бухгалтеров, членов межведомственных комиссий по организации отдыха детей и молодежи муниципальных образований РТ;</p></li>" +
        "<li><p>организация и проведение смотр-конкурса «Лучшая организация отдыха и оздоровления детей и молодёжи РТ», регионального этапа Всероссийского конкурса «Лучшая программа организации детского отдыха», а также - фестиваля палаточных лагерей «Звездный десант - новая волна»;</p></li>" +
        "</ul>"
    };
  }
};
</script>
